import type {
  webhookSubscriptionDetailResource,
  webhookSubscriptionResource,
} from '@porotutu/api/features/crm/webhook_subscriptions/resource'
import { unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { WEBHOOK_SUBSCRIPTIONS } from '@/api/keys'
import type { CrmWebhookSubscriptionSort } from '../vocabulary'

export type WebhookSubscription = ReturnType<typeof webhookSubscriptionResource>
export type WebhookSubscriptionDetail = ReturnType<typeof webhookSubscriptionDetailResource>

export type WebhookSubscriptionPage = { data: WebhookSubscription[]; meta: ListMeta }

export type WebhookSubscriptionListQuery = ListQuery<CrmWebhookSubscriptionSort, never> & {
  active?: string
}

const sent = (query: WebhookSubscriptionListQuery) => ({
  ...query,
  active: query.active === undefined ? undefined : query.active === 'true',
})

export const webhookSubscriptionsQuery = (query: WebhookSubscriptionListQuery) =>
  queryOptions({
    queryKey: [...WEBHOOK_SUBSCRIPTIONS, 'list', query] as const,
    queryFn: async () => unwrap(await crm['webhook-subscriptions'].get({ query: sent(query) })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const webhookSubscriptionQuery = (id: string) =>
  queryOptions({
    queryKey: [...WEBHOOK_SUBSCRIPTIONS, 'record', id] as const,
    queryFn: async () => unwrap(await crm['webhook-subscriptions']({ id }).get()),
    staleTime: 30_000,
  })
